import { FASTElement, html, observable } from "@microsoft/fast-element";
import { NatGenPortal } from "./portal";
import { NatGenDesignSystem } from "../../natgen-design-system";

/**
 * @element natgen-portal-outlet
 */
export class NatGenPortalOutlet extends FASTElement {
    @observable
    attachedPortals: NatGenPortal[] = [];

    onPortalUpdate(): void {
        this.textContent = '';
        this.attachedPortals.forEach(p => p.childNodes.forEach(c => this.append(c.cloneNode(true))));
    }

    attach(portal : NatGenPortal) {
        this.attachedPortals.push(portal);
        this.onPortalUpdate();
    }

    detach(portal: NatGenPortal) {
        try {
            this.attachedPortals.splice(this.attachedPortals.indexOf(portal), 1);
        } catch { }
    }
}

export const natGenPortalOutletDefinition = NatGenPortalOutlet.compose({
    name: `${NatGenDesignSystem.prefix}-portal-outlet`,
    template: html<NatGenPortalOutlet>`<slot></slot>`
});
